const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

class MarketingService {
    constructor() {
        this.token = null;
    }

    getHeaders() {
        // Получаем токен из localStorage каждый раз
        const token = localStorage.getItem('auth_token') || localStorage.getItem('auth_token');

        if (!token || token === 'demo token') {
            console.error('No valid auth token found');
        }

        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        };
    }
    async getClonesInfo(data) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/clones/info`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({
                    tarif: data.tarif,
                    level: data.level,
                    number_level: data.number_level
                }),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error getting clones info:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

// Получить все клоны пользователя
    async getAllClones() {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/clones/all`, {
                method: 'GET',
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error getting all clones:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }
    async handleResponse(response) {
        const data = await response.json();
        return data;
    }

    // Получить доступные тарифы и уровни
    async getLightBoxOptions() {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/lightbox/options`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error fetching Light Box options:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    // Проверить активацию пользователя
    async checkActivation() {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/lightbox/check-activation`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error checking activation:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    // НОВЫЙ МЕТОД: Проверить статус для конкретного тарифа и уровня
    async checkStatus(tarif, level) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/lightbox/check-status`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({ tarif, level }),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error checking status:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    // Получить корзину
    async getBasket() {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/basket`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error fetching basket:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    // Добавить в корзину
    async addToBasket(data) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/basket/add`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(data),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error adding to basket:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    // Удалить из корзины
    async removeFromBasket(id) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/basket/${id}`, {
                method: 'DELETE',
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error removing from basket:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    // Очистить корзину
    async clearBasket() {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/basket`, {
                method: 'DELETE',
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error clearing basket:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    // НОВЫЙ МЕТОД: Оплатить корзину
    async payBasket() {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/basket/pay`, {
                method: 'POST',
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error paying basket:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    // НОВЫЙ МЕТОД: Получить информацию о первом уровне
    async getFirstLevel(tarif) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/lightbox/first-level`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({ tarif }),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error getting first level:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    // НОВЫЙ МЕТОД: Купить конкретный уровень
    async buyLevel(tarif, level) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/lightbox/buy-level`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({ tarif, level }),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error buying level:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    // Просмотр позиции в дереве
    async viewPosition(data) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/view-position`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({
                    tarif: data.tarif,
                    level: data.level,
                    number_level: data.number_level,
                    mentor_id: data.mentor_id || 0
                }),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error viewing position:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    async bronPosition(data) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/bron-position`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(data),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error bron position:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    async cancelBron(data) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/cancel-bron`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(data),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error cancel bron:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    async payPosition(data) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/pay-position`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(data),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error pay position:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    async checkLevelActivation(tarif, level) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/check-level-activation`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({ tarif, level }),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error checking level activation:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    async buyLevelDirect(tarif, level) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/buy-level-direct`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({ tarif, level }),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error buying level direct:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    async searchLoginInTree(query, tarif, level) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/search-login`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({ query, tarif, level }),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error searching login in tree:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    // ── ПОДПИСКА НА АКТИВНОСТЬ ─────────────────────────────────────────

    /**
     * Получить статус маркетинговой подписки текущего пользователя.
     * Ответ содержит поле subscribed_until (ISO-строка) или null.
     */
    async getActivityStatus() {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/activity-status`, {
                method: 'GET',
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error getting activity status:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * Продлить маркетинговую подписку на 6 месяцев (стоимость 5 USD).
     * При успехе на счёт начисляется клон в тариф Start уровень 1.
     */
    async renewActivity() {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/renew-activity`, {
                method: 'POST',
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error renewing activity:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    // ========================================
    // ========== LIGHT MIX METHODS ==========
    // ========================================

    /**
     * Получить текущий активный розыгрыш Light Mix
     */
    async getLightMixCurrentDraw() {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/light-mix/current-draw`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error fetching Light Mix current draw:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * Получить историю розыгрышей Light Mix
     */
    async getLightMixHistory(limit = 20) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/light-mix/history?limit=${limit}`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error fetching Light Mix history:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * Получить статус пользователя в розыгрыше Light Mix
     */
    async getLightMixUserStatus(drawId) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/light-mix/user-status/${drawId}`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error fetching Light Mix user status:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * Купить место в розыгрыше Light Mix
     */
    async purchaseLightMixPlace(data) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/light-mix/purchase`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify(data),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error purchasing Light Mix place:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * Получить дерево маркетинга Light Mix
     */
    async getLightMixTree(program, mentorId = null) {
        try {
            const params = new URLSearchParams({ program });
            if (mentorId) {
                params.append('mentor_id', mentorId);
            }
            const response = await fetch(`${API_BASE_URL}/marketing/light-mix/tree?${params}`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error fetching Light Mix tree:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * Получить дерево Light Mix по draw_id, tarif, level
     */
    async getLightMixTreeData(drawId, positionId = null, tarif = 'mix', level = 4) {
        try {
            const params = new URLSearchParams({
                draw_id: drawId,
                tarif: tarif,
                level: level
            });
            if (positionId) {
                params.append('position_id', positionId);
            }
            const response = await fetch(`${API_BASE_URL}/marketing/light-mix/tree?${params}`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error fetching Light Mix tree data:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * Получить список тарифов
     */
    async getLightMixTarifs() {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/light-mix/tarifs`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error fetching Light Mix tarifs:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * Получить уровни для тарифа
     */
    async getLightMixLevels(tarif = 'mix') {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/light-mix/levels?tarif=${tarif}`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error fetching Light Mix levels:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * Поиск в дереве Light Mix
     */
    async searchLightMix(drawId, query, tarif = 'mix', level = 4) {
        try {
            const params = new URLSearchParams({
                draw_id: drawId,
                query: query,
                tarif: tarif,
                level: level
            });
            const response = await fetch(`${API_BASE_URL}/marketing/light-mix/search?${params}`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error searching Light Mix:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * Получить статистику пользователя по Light Mix
     */
    async getLightMixUserStats() {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/light-mix/user-stats`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error fetching Light Mix user stats:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * Получить информацию о конкретном розыгрыше Light Mix
     */
    async getLightMixDrawInfo(drawId) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/light-mix/draw/${drawId}`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error fetching Light Mix draw info:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }

    /**
     * Проверить статус покупки Light Mix
     */
    async checkLightMixPurchaseStatus(program) {
        try {
            const response = await fetch(`${API_BASE_URL}/marketing/light-mix/purchase-status/${program}`, {
                headers: this.getHeaders(),
            });
            return await this.handleResponse(response);
        } catch (error) {
            console.error('Error checking Light Mix purchase status:', error);
            return {
                success: false,
                message: 'Ошибка соединения с сервером'
            };
        }
    }
}

// ИСПРАВЛЕННЫЙ ЭКСПОРТ - именованный экспорт
export const marketingService = new MarketingService();

// Также оставляем default экспорт для обратной совместимости
export default marketingService;
